import React from 'react'

import dynamic from 'next/dynamic'

import { Button } from 'components/v2/Button'
import { Row } from 'components/v2/Grid'
import { Text } from 'components/v2/Text'

import { CONSULTATION_DURATION_MINUTES } from 'utils/consultationSchedule'

const LazyImage = dynamic(() => import('components/shared/LazyImage'), {
	ssr: false
})

const HowItWorks = ({ handleModal }) => (
	<section id='how-works'>
		<Row className='mx-auto mb-[30px] max-w-[1200px] flex-wrap px-[17px] sm:px-[10px]'>
			<Row className='mb-4 flex-wrap justify-between'>
				<div className='mb-8 flex w-full min-w-0 flex-col items-center md:mb-0 md:flex-[0_0_58%]'>
					<LazyImage
						src='/static/images/home-howitworks1.webp'
						alt='Um grupo de pessoas com a camiseta da Vittude se abraçando'
					/>
				</div>
				<div className='flex w-full min-w-0 flex-col md:flex-[0_0_42%]'>
					<Text
						as='h2'
						variant='regular'
						className='mb-3 text-2xl font-semibold text-gray-800 md:text-3xl'
					>
						Melhor rede de especialistas de saúde mental do Brasil
					</Text>
					<Text
						variant='regular'
						className='mb-3 font-medium leading-6 text-gray-800'
					>
						Na Vittude, você encontra psicólogos especialistas, selecionados com
						critérios técnicos rigorosos e credenciados junto aos Conselhos
						Regionais de Psicologia. A marca investe no desenvolvimento contínuo
						dos profissionais e oferece condições justas de trabalho, o que
						reflete diretamente na qualidade do atendimento.
					</Text>
					<Text
						variant='regular'
						className='mb-3 font-medium leading-6 text-gray-800'
					>
						Tudo acontece em um ambiente 100% seguro, com sigilo, ética e
						respeito em cada etapa da sua jornada terapêutica.
					</Text>
				</div>
			</Row>
			<Row className='mt-4 flex-wrap justify-between'>
				<div className='order-2 flex w-full min-w-0 flex-col md:order-1 md:max-w-[41.667%] md:flex-[0_0_41.667%]'>
					<Text
						as='h2'
						variant='regular'
						className='mb-3 text-2xl font-semibold text-gray-800 md:text-3xl'
					>
						Como funciona a <br />
						terapia online
					</Text>
					<Text
						variant='regular'
						className='mb-4 font-medium leading-6 text-gray-800'
					>
						A terapia acontece por videochamada, em sessões individuais, com
						duração média de {CONSULTATION_DURATION_MINUTES} minutos. O modelo é
						equivalente ao presencial e segue as diretrizes do Conselho Federal
						de Psicologia, que regulamenta a psicoterapia online no Brasil desde
						2018.
					</Text>
					<Text
						variant='regular'
						className='mb-4 font-medium leading-6 text-gray-800'
					>
						Você conversa com seu psicólogo em tempo real, em um espaço
						confidencial, usando computador ou celular.
					</Text>
					<Button
						variant='primary'
						className='h-11 w-fit text-sm font-semibold'
						id='start-now'
						onClick={handleModal}
					>
						Começar agora
					</Button>
				</div>
				<div className='order-1 mb-8 flex w-full min-w-0 flex-col md:order-2 md:mb-0 md:flex-[0_0_58%]'>
					<LazyImage
						src='/static/images/home-howitworks2.webp'
						alt='Duas pessoas fazendo uma video-chamada'
					/>
				</div>
			</Row>
		</Row>
	</section>
)

export default HowItWorks
